<div class="category_content">
  <div class="p-fluid grid w-100 category_search">
    <div class="col-10">
      <input
        type="text"
        pInputText
        placeholder="Pesquise pela pergunta"
        class="w-full"
      />
    </div>
    <div class="col-2">
      <button
        type="button"
        pButton
        label="Criar FAQ"
        icon="pi pi-plus-circle"
        severity="success"
        (click)="toggleDialog()"
      ></button>
    </div>
  </div>

  <ng-container *ngIf="pagination.data?.length; else noData">
    <div class="faq-container">
      <div
        class="faq-card"
        *ngFor="let faq of faqs"
        [class.inactive]="!faq.ativo"
      >
        <div class="faq-header" (click)="faq.open = !faq.open">
          <div class="faq-title">
            <i class="pi pi-question-circle"></i>
            <span>{{ faq.pergunta }}</span>
          </div>

          <i
            class="pi"
            [ngClass]="faq.open ? 'pi-chevron-up' : 'pi-chevron-down'"
          >
          </i>
        </div>

        <div class="faq-body" [class.open]="faq.open">
          <p>{{ faq.resposta }}</p>
        </div>

        <div class="faq-actions">
          <button
            pButton
            icon="pi pi-trash"
            class="p-button-rounded p-button-text p-button-danger"
            (click)="deleteFAQ(faq?.id)"
          ></button>

          <button
            pButton
            class="p-button-rounded p-button-text"
            [icon]="faq.ativo ? 'pi pi-eye-slash' : 'pi pi-eye'"
            (click)="toggleFAQ(faq)"
          ></button>
        </div>
      </div>
    </div>
    <div class="pagination-controls">
      <app-paginator-control
        [first]="
          ((pagination.pageNumber ?? 1) - 1) * (pagination.pageSize ?? 10)
        "
        [rows]="pagination.pageSize ?? 10"
        [totalRecords]="pagination.totalRecords ?? 0"
        (pageChange)="onPageChange($event)"
      >
      </app-paginator-control>
    </div>
  </ng-container>
  <ng-template #noData>
    <div class="no-data">
      <app-data-void
        titulo="Nenhuma FAQ encontrada"
        descricao="Clique em Criar FAQ para cria uma nova!"
      />
    </div>
  </ng-template>
</div>

<!-- Adicionar nova FAQ -->
<p-dialog
  header="Adicionar Pergunta Frequente"
  [modal]="true"
  [(visible)]="showCreateDialog"
  [style]="{ width: '30rem' }"
>
  <form [formGroup]="formFAQ" class="p-fluid grid">
    <div class="col-12 field flex flex-column gap-2">
      <label for="pergunta">Pergunta</label>
      <input
        type="text"
        pInputText
        placeholder="Insira a pergunta"
        class="w-full"
        formControlName="pergunta"
        (invalid)="isInvalid('pergunta')"
      />
      <small class="error" *ngIf="isInvalid('pergunta')"
        >Pergunta é obrigatória.</small
      >
    </div>

    <div class="col-12 field flex flex-column gap-2">
      <label for="resposta">Resposta</label>
      <input
        type="text"
        pInputText
        placeholder="Insira a resposta"
        class="w-full"
        formControlName="resposta"
        (invalid)="isInvalid('resposta')"
      />
      <small class="error" *ngIf="isInvalid('resposta')"
        >Resposta é obrigatória.</small
      >
    </div>

    <div class="flex justify-content-between gap-2 col-12">
      <p-button
        label="Cancelar"
        severity="secondary"
        (click)="toggleDialog()"
      />
      <button class="btn_one" (click)="saveFAQ()" [disabled]="loading">
        {{ loading ? "Guardando..." : "Guardar" }}
        <i class="pi pi-spinner" *ngIf="loading"></i>
      </button>
    </div>
  </form>
</p-dialog>
